<template>
  <div
    v-if="isEditMode || headline.value || text.value"
    class="icon-text-element-fi"
  >
    <!-- eslint-disable vue/no-v-html -->
    <div class="icon-text-element-fi__container">
      <span
        :class="{
          'icon-text-element-fi__icon': true,
          'icon-text-element-fi__icon--default': iconName === 'check' && !isEditMode,
        }"
      >
        <span
          v-if="isEditMode && iconModified"
          class="icon-text-element-fi__icon-svg"
          v-html="iconModified.editable"
        />
        <icon-fi
          v-else
          class="icon-text-element-fi__icon-svg"
          :icon="iconName"
          :size="isSM ? '2' : '1'"
        />
      </span>
      <template v-if="isEditMode">
        <div
          v-if="headline"
          class="icon-text-element-fi__headline sm:fi-mb-6"
          v-html="headline.editable"
        />
        <div
          v-if="text"
          class="icon-text-element-fi__text"
          v-html="text.editable"
        />
      </template>
      <template v-else>
        <headline-fi
          v-if="headline?.value"
          class="icon-text-element-fi__headline sm:fi-mb-6"
          tag="div"
          :size="24"
          :field="headline"
        />
        <div
          v-if="text.value"
          class="icon-text-element-fi__text"
        >
          {{ text.value }}
        </div>
      </template>
    </div>
    <!-- eslint-enable vue/no-v-html -->
  </div>
</template>

<script setup lang="ts">
import { HeadlineFi, IconFi } from 'atoms/index';
import { useBreakpoints } from 'composables/breakpoint';
import useIcon from 'composables/icon';

import type { SingleLineTextField } from '@/sitecoreFieldTypes';

defineOptions({
  name: 'IconTextElementFi',
});

const props = withDefaults(
  defineProps<{
    icon?: object;
    headline?: SingleLineTextField;
    text?: SingleLineTextField;
  }>(),
  {
    icon: () => ({}),
    headline: () => ({}),
    text: () => ({}),
  },
);

const { isSM } = useBreakpoints();
const { iconName, iconModified } = useIcon(props);
</script>

<style lang="scss" scoped>
@import './icon-text-element-fi';
</style>

<style lang="scss">
@import './icon-text-element-fi-unscoped';
</style>
